import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from './SoundAssetKeys';

/** @type {Phaser.Sound.HTML5AudioSound} */
let jingle = null;

/** @type {Phaser.Sound.HTML5AudioSound} */
let jingleFast = null;

/**
 * 
 * @param {Phaser.Scene} scene 
 */
export function setup(scene) {
  jingle = ABCyaPhaser.Audio.createSound(scene);
  jingleFast = ABCyaPhaser.Audio.createSound(scene);
}

export function playJingle() {
  ABCyaPhaser.Audio.playSound(SoundAssetKeys._pixel_bells, jingle, 1, true);
  ABCyaPhaser.Audio.playSound(SoundAssetKeys._pixel_bells_fast, jingleFast, 0, true);
}

export function stopJingle() {
  jingle.stop();
  jingleFast.stop();
}

/**
 * 
 * @param {Phaser.Scene} scene 
 */
export function playNormalTempo(scene) {
  scene.tweens.killTweensOf(jingle);
  scene.tweens.killTweensOf(jingleFast);

  const percentIn = jingleFast.seek / jingleFast.duration;
  scene.tweens.add({
    targets: jingle,
    duration: 120,
    props: { volume: 0.5 },
    ease: Phaser.Math.Easing.Linear
  });
  jingle.seek = jingle.duration * percentIn;
  scene.tweens.add({
    targets: jingleFast,
    duration: 120,
    props: { volume: 0 },
    ease: Phaser.Math.Easing.Linear
  });
}

/**
 * 
 * @param {Phaser.Scene} scene 
 */
export function playFastTempo(scene) {
  scene.tweens.killTweensOf(jingle);
  scene.tweens.killTweensOf(jingleFast);

  const percentIn = jingle.seek / jingle.duration;
  scene.tweens.add({
    targets: jingle,
    duration: 120,
    props: { volume: 0 },
    ease: Phaser.Math.Easing.Linear
  });
  jingleFast.seek = jingle.duration * percentIn;
  scene.tweens.add({
    targets: jingleFast,
    duration: 120,
    props: { volume: 0.5 },
    ease: Phaser.Math.Easing.Linear
  });
}